export default __webpack_public_path__ + "static/media/manarw.eb64fba3.svg";